import { render, staticRenderFns } from "./EntAssets.vue?vue&type=template&id=3155a489&scoped=true"
import script from "./EntAssets.vue?vue&type=script&lang=js"
export * from "./EntAssets.vue?vue&type=script&lang=js"
import style0 from "./EntAssets.vue?vue&type=style&index=0&id=3155a489&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155a489",
  null
  
)

export default component.exports